// @flow

export class StaleChunkError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'StaleChunkError';
  }
}
